import React from 'react';
import Typist from 'react-typist';
import transFunction from '../trans-function';

const typingDelay = (targets) => transFunction(targets, 'delay', (match, regexClear) => {
  const mClean = match.replace(regexClear, '');
  const rand = Math.random();
  return (<Typist.Delay ms={mClean} key={rand} />);
});

export default typingDelay;
